<template>
  <div class="material-header">
    <div class="material-info">
      <p class="text-sm text-secondary text-uppercase mb-4">
        <span class="bold" v-if="content.material_purpose">{{content.material_purpose.name}}</span>
        <span class="bold" v-if="content.categories.material_type"> | {{content.categories.material_type.name}}</span>
        <span v-if="content.content_type"> | {{content.content_type.name}}</span>
      </p>
      <div class="material-applications" v-if="content.acf.applications">
        <div v-for="application in content.acf.applications" :key="application.text"
             class="d-flex justify-content-start align-items-center">
          <img :src="application.icon" class="mr-3">
          <div>
            <p v-html="application.text" class="bold m-0"></p>
            <p v-html="application.additional_text" class="m-0"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    content: Object,
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/common.scss';
.material-header {
  padding-bottom: 2.5rem;
}
.material-info {
  padding-left: 2rem;
  border-left: 1px solid $primary;
}
.material-applications {
  margin-top: auto;
  width: 100%;
  font-size: 15px;
  > div {
    &:first-child p:first-child {
      font-size: 24px;
    }
    &:not(:last-of-type) {
      margin-bottom: 1em;
    }
  }
  img {
    max-width: 45px;
    width: 100%;
    filter: $filter-to-lightgrey;
  }
}
@include media-breakpoint-down(lg) {
  .material-applications {
    font-size: 13px;
    div:first-child p:first-child {
      font-size: 15px;
    }
  }
}
</style>
